import {ChangeDetectorRef, Component, Input, OnInit, ViewChild} from '@angular/core';
import {IMessengerConnector, Message} from '../../../../types/all.type';
import {NgxModalDraggableDirective} from '../../../../directives/draggable.directive';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {SenderHistoryResults} from '../../../../types/sende.type';

@Component({
  selector: 'app-modal-serros-contacts',
  templateUrl: './modal-serros-contacts.component.html',
  styleUrls: ['./modal-serros-contacts.component.scss']
})
export class ModalSerrosContactsComponent implements OnInit {
  @Input() modalMode = false;
  @Input() Service: IMessengerConnector;
  @Input() sender: SenderHistoryResults;
  public modalDirective: NgxModalDraggableDirective;
  langs: any = {
    ru: {
      JOIN_NOT_HELP: 'Не помогла подписка',
      USERNAME_INVALID: 'Адрес не найден',
      USERNAME_NOT_OCCUPIED: 'Адрес свободен',
      CHANNEL_PRIVATE: 'Приватный канал',
      CHAT_RESTRICTED: 'Чат ограничен',
      USERNAME_NOT_FOUND: 'Чат не найден',
      'TYPE_CHAT_ERROR:channel': 'Является каналом'

    }
  };

  @ViewChild(NgxModalDraggableDirective)
  set setDirective(directive: NgxModalDraggableDirective) {
    this.modalDirective = directive;
  }
  constructor(private cd: ChangeDetectorRef, public bsModalRef: BsModalRef) {
  }
  get fatalErrors(): any {
    return JSON.parse(this.sender?.contacts_fatal || '{}');
  }
  get fatalErrorsKeys(): any {
    return Object.keys(this.fatalErrors);
  }

  ngOnInit(): void {
  }
  color(error: string): string {
    switch (error) {
      case 'JOIN_NOT_HELP':
        return 'warning';
      case 'USERNAME_INVALID':
        return 'warning';
      case 'USERNAME_NOT_OCCUPIED':
        return 'info';
      case 'TYPE_CHAT_ERROR:channel':
      default:
        return 'danger';

    }
  }
}
